export interface IVersionData {
  id: string;
  version: string;
}
